import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { TESTIMONIALS } from '../mock/data';

export default function Testimonials() {
  const [i, setI] = useState(0);
  const n = TESTIMONIALS.length;

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % n), 7000);
    return () => clearInterval(t);
  }, [n]);

  const t = TESTIMONIALS[i];

  return (
    <section id="reviews" className="py-24 lg:py-32 bg-ink relative">
      <div className="max-w-5xl mx-auto px-5 md:px-8 text-center">
        <div className="eyebrow justify-center inline-flex">What Neighbors Say</div>
        <h2 className="section-title">Real reviews. Real jobs. Real people.</h2>

        <div className="mt-12 relative">
          <Quote className="w-14 h-14 text-gold/40 mx-auto" />
          <blockquote className="mt-4 font-display uppercase text-2xl md:text-3xl leading-snug text-cream max-w-3xl mx-auto min-h-[8rem] tracking-tight">
            &ldquo;{t.text}&rdquo;
          </blockquote>
          <div className="mt-6 flex justify-center gap-1">
            {Array.from({ length: t.rating }).map((_, k) => (
              <Star key={k} className="w-5 h-5 fill-gold text-gold" />
            ))}
          </div>
          <div className="mt-3 text-cream font-semibold">{t.name}</div>
          <div className="text-cream/50 text-sm">{t.city}</div>

          <div className="mt-10 flex items-center justify-center gap-3">
            <button
              aria-label="Previous"
              onClick={() => setI((v) => (v - 1 + n) % n)}
              className="w-11 h-11 rounded-full border border-white/15 hover:bg-gold hover:text-ink hover:border-gold text-cream flex items-center justify-center transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-1.5">
              {TESTIMONIALS.map((_, k) => (
                <button
                  key={k}
                  aria-label={`Go to ${k + 1}`}
                  onClick={() => setI(k)}
                  className={`h-1.5 rounded-full transition-[width,background] duration-300 ${
                    k === i ? 'w-8 bg-gold' : 'w-1.5 bg-cream/25'
                  }`}
                />
              ))}
            </div>
            <button
              aria-label="Next"
              onClick={() => setI((v) => (v + 1) % n)}
              className="w-11 h-11 rounded-full border border-white/15 hover:bg-gold hover:text-ink hover:border-gold text-cream flex items-center justify-center transition-colors"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
